<script setup lang="ts">
const rowHeight = ref(42) // Height of each row in the loading state
const rows = ref(2) // Number of rows to display in the loading state
</script>

<template>
  <div class="loading-skeleton flex flex-col gap-4 mt-2 px-3">
    <div
      v-for="index in rows"
      :key="`empty-state-omni-search-row-${index}`"
      class="flex items-center gap-4 animate-pulse"
      :style="{ height: `${rowHeight}px` }"
    >
      <div class="rounded-lg bg-surface-grey h-full" :style="{ width: `${rowHeight}px` }"/>
      <div class="rounded-lg bg-surface-grey flex-grow h-full"/>
    </div>
  </div>
</template>
